import React, { useLayoutEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
const Scroll = ({ children, position, progress = 0 }) => {
  const [mode, setMode] = useState("waiting");

  useLayoutEffect(() => {
    let updatedMode = "waiting";
    if ( progress > 0 && progress < 100 ) {
      updatedMode = "active";
    }
    else if ( progress === 100 ) {
      updatedMode = "complete";
    }
    setMode(prevMode  => updatedMode)
  }, [progress, setMode])
  return (
    <StyledScroll 
      position={position ? position : undefined} className={`is-${mode}`} style={{ "--height" : `${progress}%`}}>
      <div>
      </div>
    </StyledScroll>
  )

}

export default Scroll;

const move = keyframes`
  0%,
  10% {
    transform: translate3d(0,-100%,0);
  }
  49%,
  51% {
    transform: translate3d(0,0%,0);
  }
  100% {
    transform: translate3d(0,100%,0);
  }
`;

const StyledScroll = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  height: 100%;
  ${props => props.position === "bottom-center" && css`
    justify-content: center;
  `}

  div {
    position: relative;
    height: 100%;
    min-height: 3em;
    width: 3px;
    margin-left: -1.5px;
    overflow: hidden;
    transition: opacity 0.4s ease;
    opacity: 1;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: currentColor;
      opacity: 0;
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      width: 100%;
      left: 0;
      height: 30%;
      background-color: currentColor;
      opacity: 1;
    }
  }
  &.is-waiting div::after {
    height: 100%;
    animation: ${move} 3s var(--bezier) infinite;
  }
  &.is-active div::after {
    height: 100%;
    top: auto;
    bottom: 100%;
    transform: translate3d(0,var(--height),0);
    transition: transform var(--inertia) ease-out;
  }
  &.is-complete  div{
    opacity: 0;
    &::after {
      height: 100%;
    }
  }
`;
export { StyledScroll }

/*
const Scroll = ({ children, position }) => (
  <StyledScroll position={position ? position : undefined}>
    {children && <span>{children}</span>}
    <div>
      <ArrowDown />
    </div>
  </StyledScroll>
)

export default Scroll;

const arrow = keyframes`
  0% {
    transform: translate3d(0,0,0);
  }
  40% {
    transform: translate3d(0,80%,0);
  }
  100% {
    transform: translate3d(0,0,0);
  }
`;

const StyledScroll = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 1.5em;
  font-size: 0.875em;

  ${props => props.position === "bottom-center" && css`
    justify-content: center;
  `}

  span {
    display: block;
    margin-bottom: 0.5em;
  }
  div {
    display: block;
    margin: 0 auto;
    animation: ${arrow} 4s ease infinite;
  }
`;
export { StyledScroll }
*/